import script from "./HtmlConstructorBlockProperties.vue?vue&type=script&lang=ts&setup=true"
export * from "./HtmlConstructorBlockProperties.vue?vue&type=script&lang=ts&setup=true"

import "./HtmlConstructorBlockProperties.vue?vue&type=style&index=0&id=38b73346&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b73346"]])

export default __exports__